export interface Account {
  label: string
  value: string
}

export const accountType: Account[] = [
  {
    label: 'Corrente',
    value: 'CC',
  },
  {
    label: 'Poupança',
    value: 'CP',
  },
]
